<template>
  <DModal :show-close="false" :isBgOverlay="true" :isCloseOnBgClick="false" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal text-dark" slot="insertComponent">
      <div class="d-modal__header">
        <div>
          <h2>Opret faste tillæg</h2>
          <p class="d-modal__subtitle">{{ subtitleText }}</p>
        </div>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="create-form__grid">
          <div class="d-input-group cf-tillaeg">
            <label class="d-label">Lønkode *</label>
            <DSelect
              ref="tillaegSelect"
              :items="salaryCodesForDSelect"
              :multiple="false"
              :placeholder="'Vælg tillæg'"
              :itemsSelected="selectedSalaryCodeForDSelect"
              :isShowRemoveButton="false"
              @add="onSelectTillaeg"
              @remove="onSelectTillaeg(null)"
            />
          </div>
          <div class="d-input-group cf-antal">
            <label class="d-label">Enheder pr. måned *</label>
            <input v-model="antal" type="text" inputmode="decimal" class="d-input width-100" placeholder="Indtast antal"/>
          </div>
          <div class="d-input-group cf-start">
            <label class="d-label">Startdato *</label>
            <DateSelector class="width-100" :date="startDato" :width100="true" @changed="startDato = $event"/>
          </div>
          <div class="d-input-group cf-slut">
            <label class="d-label">Slutdato *</label>
            <DateSelector class="width-100" :date="endDato" :width100="true" @changed="endDato = $event"/>
          </div>
        </div>
        <p v-if="validationMessage" class="text-explainer text-explainer--danger">{{ validationMessage }}</p>
      </div>

      <div class="d-modal__buttons">
        <div class="d-modal__buttons__child">
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit"
                  :class="{'do-bttn--submit--loading': isSubmitting, 'do-bttn--submit--disabled': !isValid}"
                  :disabled="!isValid || isSubmitting"
                  @click="submit"
                  :content="saveKeyTooltip"
                  v-tippy="{
                    arrow: true,
                      placement : 'top',
                      animateFill: false,
                      animation : 'shift-away',
                      boundary: 'window',
                      zIndex: 12312312312312
                    }">
            {{ submitButtonLabel }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import DateSelector from '../../datepicker/DateSelector.vue'
import moment from 'moment'
import eventbus from '../../../eventbus'
import docendo from '../../../docendo'
import DSelect from '../../DSelect/DSelect.vue'

export default {
  components: {DSelect, DModal, DateSelector},
  props: {
    schoolId: {
      type: Number,
      required: true
    },
    employmentIds: {
      type: Array,
      default: () => []
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      salaryCodeId: null,
      antal: '',
      startDato: null,
      endDato: null,
      isSubmitting: false,
      validationMessage: ''
    }
  },
  computed: {
    metaKey () {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return isMac ? '⌘' : 'CTRL'
    },
    saveKeyTooltip () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>'
    },
    subtitleText () {
      if (this.subtitle) return this.subtitle
      return 'På ' + this.employmentIds.length + ' ' + (this.employmentIds.length === 1 ? 'ansættelse' : 'ansættelser')
    },
    submitButtonLabel () {
      if (this.employmentIds.length <= 1) return 'Opret fast tillæg'
      return 'Opret ' + this.employmentIds.length + ' faste tillæg'
    },
    isValid () {
      const hasSelections = this.employmentIds.length > 0
      const hasStart = !!this.startDato && moment(this.startDato).isValid()
      const hasEnd = !!this.endDato && moment(this.endDato).isValid()
      const hasTillaeg = this.salaryCodeId != null
      const antal = parseFloat(String(this.antal).replace(',', '.'))
      const hasAntal = !isNaN(antal) && antal >= 0.0001 && antal <= 999.9999
      const isEndAfterStart = hasEnd && hasStart && moment(this.endDato).isSameOrAfter(moment(this.startDato))
      return hasSelections && hasStart && hasEnd && hasTillaeg && hasAntal && isEndAfterStart
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted || []
    },
    // Kun lønkoder med et tillaegsnummer kan bruges som fast tillæg i SD.
    salaryCodesForDSelect () {
      if (!this.salaryCodes || !Array.isArray(this.salaryCodes)) return []
      return this.salaryCodes
        .filter(sc => sc.tillaegsnummer)
        .map(sc => {
          return {
            id: sc.id,
            name: sc.vSupplementTitle,
            value: sc.tillaegsnummer,
            original: sc
          }
        })
    },
    selectedSalaryCodeForDSelect () {
      if (this.salaryCodeId == null) return []
      const found = this.salaryCodesForDSelect.find(item => item.id === this.salaryCodeId)
      return found ? [found] : []
    },
    employmentsById () {
      const map = {}
      const list = (this.$store.state.employments && this.$store.state.employments.employments) || []
      for (let i = 0; i < list.length; i++) map[list[i].id] = list[i]
      return map
    },
    employmentsGroupedByUser () {
      const groups = {}
      const byId = this.employmentsById
      for (let i = 0; i < this.employmentIds.length; i++) {
        const id = this.employmentIds[i]
        const emp = byId[id]
        const userId = emp ? emp.user_id : null
        const key = userId != null ? String(userId) : 'unknown'
        if (!groups[key]) groups[key] = {userId: userId, employmentIds: []}
        groups[key].employmentIds.push(id)
      }
      return Object.keys(groups).map(k => groups[k])
    },
    // Datoerne følger som udgangspunkt skoleårets medarbejderperiode.
    schoolYearStartDate () {
      const year = this.$store.state.localActivatedSchoolYear
      const firstOfNextMonth = moment().add(1, 'month').startOf('month')
      if (year && year.employee_time_start) {
        const start = moment(year.employee_time_start)
        // Hvis skoleårets start allerede er overskredet, brug den første i næste måned.
        return start.isBefore(moment(), 'day') ? firstOfNextMonth : start
      }
      return firstOfNextMonth
    },
    schoolYearEndDate () {
      const year = this.$store.state.localActivatedSchoolYear
      if (year && year.employee_time_end) {
        return moment(year.employee_time_end)
      }
      return moment().add(1, 'year').endOf('month')
    }
  },
  methods: {
    onSelectTillaeg (item) {
      this.salaryCodeId = item ? item.id : null
    },
    onGlobalKeydown (evt) {
      const isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13)
      if (!isSubmitCombo) return
      if (this.isSubmitting || !this.isValid) return
      evt.preventDefault()
      this.submit()
    },
    submit () {
      this.validationMessage = ''
      if (!this.isValid) {
        this.validationMessage = 'Udfyld tillæg, antal, startdato og slutdato'
        return
      }
      if (!this.schoolId) {
        this.validationMessage = 'Mangler schoolId'
        return
      }

      const baseTillaeg = {
        salary_code_id: this.salaryCodeId,
        startdato: moment(this.startDato).format('YYYY-MM-DD'),
        slutdato: moment(this.endDato).format('YYYY-MM-DD'),
        enheder: parseFloat(String(this.antal).replace(',', '.'))
      }

      const groups = this.employmentsGroupedByUser
      this.isSubmitting = true
      let pending = groups.length
      let createdCount = 0
      let hadError = false

      const finish = () => {
        if (pending > 0) return
        this.isSubmitting = false
        if (hadError) {
          this.validationMessage = 'Kunne ikke oprette alle faste tillæg'
          eventbus.toast = {text: 'Kunne ikke oprette alle faste tillæg', success: false, position: 'bottomLeft'}
          return
        }
        eventbus.toast = {
          text: (createdCount === 1 ? 'Fast tillæg' : createdCount + ' faste tillæg') + ' lagt i udbakken. De sendes automatisk til SD.',
          success: true,
          position: 'bottomLeft'
        }
        this.$emit('created')
        this.$emit('close')
      }

      groups.forEach(group => {
        const tillaeg = Object.assign({}, baseTillaeg)
        if (group.userId != null) tillaeg.user_id = group.userId
        docendo.bulkCreateSilkeborgDataTillaeg(
          this.schoolId,
          group.employmentIds,
          tillaeg,
          success => {
            pending--
            if (success && success.status === 'error') {
              hadError = true
            } else {
              // Hver ansættelse giver to linjer (O+S); tæl pr. ansættelse.
              createdCount += group.employmentIds.length
            }
            finish()
          },
          failure => {
            console.log('failure', failure)
            pending--
            hadError = true
            finish()
          }
        )
      })
    }
  },
  created () {
    this.startDato = this.schoolYearStartDate
    this.endDato = this.schoolYearEndDate
  },
  mounted () {
    if (!this.salaryCodes.length) this.$store.dispatch('readSalaryCodes')
    window.addEventListener('keydown', this.onGlobalKeydown)
    this.didAddNoScroll = !document.body.classList.contains('no-scroll')
    if (this.didAddNoScroll) {
      document.body.classList.add('no-scroll')
    }
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.tillaegSelect) this.$refs.tillaegSelect.setFocus()
      }, 300)
    })
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onGlobalKeydown)
    if (this.didAddNoScroll) {
      document.body.classList.remove('no-scroll')
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 640px;
  max-width: calc(100vw - 32px);
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.d-modal__subtitle {
  margin: 0.25rem 0 0;
  font-size: 13px;
  color: #6b7280;
}

.d-modal__content {
  padding: 1rem;
  overscroll-behavior: contain;
  max-height: calc(100vh - 52px - 80px);
  overflow-y: auto;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #eee;
  margin: 0;
}

.d-modal__buttons__child {
  display: flex;
  gap: 0.5rem;
}

.create-form__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.cf-tillaeg {
  grid-column: 1 / -1;
  grid-row: 1;
}

.cf-antal {
  grid-column: 1;
  grid-row: 2;
}

.cf-start {
  grid-column: 1;
  grid-row: 3;
}

.cf-slut {
  grid-column: 2;
  grid-row: 3;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 0.5rem;
}

.text-explainer--danger {
  color: var(--danger);
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// SdCreateFastTillaeg.vue?633052ed